import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Google Tag Manager dataLayer push — measurement must never break the page.
export const gtmPush = (event, params = {}) => {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
  } catch (e) {
    /* noop */
  }
};

// GA4 direct event (gtag.js) — names kept exactly as configured by the practice.
// send_to is REQUIRED: GTM (GTM-5NGZ2HLN) loads first and owns the G-3WL8EK4S8X
// destination, so plain gtag("event") calls without send_to are silently dropped.
const GA4_ID = "G-3WL8EK4S8X";
const ga4Event = (name, beacon, params = {}) => {
  try {
    if (typeof window.gtag === "function") {
      const p = { ...params, send_to: GA4_ID };
      if (beacon) p.transport_type = "beacon";
      window.gtag("event", name, p);
    }
  } catch (e) {
    /* noop */
  }
};

// internal event -> { GTM dataLayer event, GA4 event name, fixed params }
// NO name/email/phone/health details may ever be included in params.
const EVENT_MAP = {
  booking_click: { gtm: "book_click", ga4: "Schedule an Appt", beacon: true },
  call_click: { gtm: "call_click", ga4: "Click Call - Web button", beacon: true, withPath: true },
  quiz_complete: { gtm: "quiz_submit", ga4: "quiz_submit" },
  deposit_paid: { gtm: "deposit_paid", ga4: "deposit_paid" },
  appointment_request: {
    gtm: "appointment_request_submit", ga4: "appointment_request_submit",
    params: { form_name: "appointment_request" }, withPath: true,
  },
  contact_submit: {
    gtm: "inquiry_submit", ga4: "inquiry_submit",
    params: { form_name: "inquiry" }, withPath: true,
  },
};

export const pushMarketingEvent = (internal, extra = {}) => {
  const m = EVENT_MAP[internal];
  if (!m) return;
  const params = { ...(m.params || {}), ...extra };
  if (m.withPath) params.page_path = window.location.pathname;
  gtmPush(m.gtm, params);
  ga4Event(m.ga4, m.beacon, params);
};

// deposit_paid must fire at most once per order: both the booking popup and the
// /deposit-confirmed page poll for PAID (in different tabs), so the guard uses
// localStorage keyed by order_id.
export const pushDepositPaid = (orderId) => {
  try {
    const key = `deposit_paid_${orderId}`;
    if (localStorage.getItem(key)) return;
    localStorage.setItem(key, "1");
  } catch (e) {
    /* storage unavailable: still push once below */
  }
  pushMarketingEvent("deposit_paid");
};

// Internal events that also push marketing events when reported via track().
// call_click is intentionally excluded: it is pushed once by the global tel:
// click listener in App.js (components also call track(variant, "call_click")
// for first-party stats, which must not double-push to GTM).
const TRACK_PUSHES = new Set(["booking_click", "quiz_complete", "appointment_request", "contact_submit"]);

export const track = (variant, event, step) => {
  try {
    if (TRACK_PUSHES.has(event)) pushMarketingEvent(event);
    axios.post(`${API}/events`, { variant, event, step }).catch(() => {});
  } catch (e) {
    /* measurement must never break the page */
  }
};
